import * as actionTypes from "../actions/locales/actionTypes";

const initialState = {
    locales: null,
    locale: 'en',
    loaded: false
};

const reducer = (state = initialState, {type, ...action}) => {
    switch(type) {
        case actionTypes.GET_LOCALES_SUCCEEDED:
            const {locales} = action;
            return {
                ...state,
                locales
            };
        case actionTypes.LOAD_LOCALE_SUCCEEDED: {
            const {locale} = action;
            return {
                ...state,
                locale,
                loaded: true
            };
        }
        case actionTypes.CHANGE_LOCALE_SUCCEEDED:
            const {locale} = action;
            return {
                ...state,
                locale
            };
        default:
            return state;
    }
};

export default reducer